/***
 *
 *   ORG SUBDOMAIN LANDING
 *   Phase 10 — token pass. Shows org identity + optional description.
 *   Public project listing needs an unauthenticated list API (not available).
 *
 **********/

import React from 'react';
import { useApiContext } from 'app/api.js';
import { useQuery } from 'react-query';
import LetteredAvatar from 'lettered-avatar';
import Style from './main.tailwind.js';
import { navigateRoot } from 'utilities/routes.js';
import { Loader } from 'components/lib';

export function AccountPage(props) {
    const { subdomain } = props;
    const { callApi } = useApiContext();

    const account = useQuery(['accountDomain', subdomain], () =>
        callApi({ url: `/api/account/domain/${subdomain}`, auth: false }),
    );

    const accountNotFound = account.isSuccess && !account.data?.data?.account;

    if (accountNotFound) {
        navigateRoot('/404');
        return null;
    }

    const accountData = account.data?.data?.account;

    return (
        <div className={Style.page}>
            {account.isLoading || !accountData ? (
                <div className={Style.loading}>
                    <Loader />
                </div>
            ) : (
                <div className={Style.card}>
                    <LetteredAvatar
                        name={accountData.name}
                        imgSrc={accountData.file_path}
                        options={{ imgClass: Style.logoImg }}
                    />
                    <h1 className={Style.title}>{accountData.name}</h1>
                    {accountData.description && (
                        <p className={Style.description}>{accountData.description}</p>
                    )}
                </div>
            )}
        </div>
    );
}
